<!--结果公告-->
<template>
  <div class="resout">
    <div class="notice-info-show1" :style="noticeStyle">
      <div class="result-title">
        <span>{{name}}</span>
        <br />
      </div>
      <span class="analysis">{{about}}</span>
      <br />
      <a class="more" href="javascrip:void(0)" @click="showbut">查看更多</a>
    </div>
    <div class="notice-info-show2">
      <div class="notice-title">
        <span class="title-type">类型</span>
        <span class="center-title">标题</span>
        <span class="organize">发布组织</span>
        <span class="publish-time">发布日期</span>
      </div>
      <div class="notice-border-bottom"></div>
      <div class="notice-list">
        <ul>
          <li v-for="(res,i) in results.slice(0,7)" :key="i">
            <a href="javascrip:void(0)" @click="jumpToDetail(res.noticeId,res.type)">
              <span class="status" :title="res.result">{{res.result}}</span>
              <span
                class="title-content"
                style="width=334px;margin-right=55px;"
                :title="res.noticeName"
              >{{res.noticeName}}</span>
              <span class="organize-content">{{res.org}}</span>
              <span class="time-content">{{res.publish_time.substring(0,11)}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let notice = JSON.parse(this.$supMainPageConfig);
    this.theme = JSON.parse(this.$supMainPageConfig).catItemImg.info7.theme;
    return {
      modelList: notice.resultShow.info.length,
      name: notice.resultShow.name,
      about: JSON.parse(this.$supMainPageConfig).catItemImg.info4.about,
      results: notice.resultShow.info,
      show: false,
      showT: this.theme
    };
  },
  mounted() {
    //对数组根据时间降序
    this.results.sort(function(a, b) {
      return b["publish_time"].localeCompare(a["publish_time"]);
    });
  },
  methods: {
    jumpToDetail(noticeId, type) {
      let param = "";
      param = "&noticeId=" + noticeId;
      const base = window.location.href.split("/isv/")[0];
      if (type == "中标结果公告") {
        let url = base + "/index.html?formId=bid_announcement_preview" + param;
        window.open(url, "_blank");
      } else if (type == "询价结果公告") {
        let url = base + "/index.html?formId=quo_notice" + param;
        window.open(url, "_blank");
      } else if (type == "竞价结果公告") {
        let url = base + "/index.html?formId=quo_notice" + param;
        window.open(url, "_blank");
      }
    },
    jumpToList(link, biztype) {
      let param = "";
      param = "&biztype=" + biztype;
      let url = link + param;
      window.open(url, "_blank");
    },
    showbut() {
      this.$emit("funck", this.show);
    }
  },
  computed: {
    noticeStyle: function() {
      let noticeImgSrc = JSON.parse(this.$supMainPageConfig).catItemImg.info4
        .noticeImgSrc;
      return {
        backgroundImage: "url(" + noticeImgSrc + ")",
        backgroundRepeat: "no-repeat",
        height: "409px",
        width: "40%",
        borderRadius: "5px 0px 0px 5px"
      };
    }
  }
};
</script>

<style scoped lang="scss">
.resout {
  width: 1200px;
  height: 409px;
  margin: 0 auto;
  margin-top: 63px;
  display: flex;
}
.notice-info-show1 {
  float: left;
  width: 100%;
}
.notice-info-show1 .result-title {
  height: 56px;
  font-size: 40px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 56px;
  letter-spacing: 2px;
  margin-top: 24px;
  margin-left: 24px;
  margin-bottom: 4px;
}
.notice-info-show1 .analysis {
  margin-left: 24px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}

.notice-info-show1 .more {
  display: inline-grid;
  margin-left: 24px;
  margin-top: 8px;
  width: 100px;
  height: 32px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(107, 110, 131, 1);
  line-height: 32px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 0px;
  text-align: center;
  text-decoration: none;
}

.notice-info-show2 {
  float: left;
  width: 100%;
  height: 409px;
  background: #ffffff;
  border-radius: 0px 5px 5px 0px;
}

.notice-title {
  margin-left: 24px;
  padding-top: 26px;
}

.notice-title span {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  letter-spacing: 1px;
  font-weight: bold;
  margin-left: -1px;
}

.notice-title .title-type {
  margin-right: 34px;
}
.notice-title span.organize {
  margin-left: 330px;
}

.notice-title span.publish-time {
  margin-left: 198px;
}

.notice-border-bottom {
  margin-left: 24px;
  margin-right: 22px;
  margin-top: 22px;
  border-bottom: 1px solid #dadada;
}

.notice-list ul {
  list-style: none;
  padding-left: 24px;
}
.notice-list ul li a {
  color: inherit;
  text-decoration: none;
}

.notice-list ul li a:hover {
  background-color: #f2f6fc;
}

.notice-list img {
  width: 45px;
  height: 18px;
  align-items: center;
  margin-right: 12px;
  vertical-align: sub;
}
.notice-list ul li {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(41, 44, 64, 1);
  line-height: 22px;
  margin-bottom: 22px;
}

.notice-list ul li .title-content {
  width: 330px;
  padding-right: 35px;
  display: inline-block;
  max-width: 330px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 12px;
}

.notice-list ul li .organize-content {
  width: 220px;
  padding-right: 45px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-list ul li .time-content {
  width: 107px;
  display: inline-block;
}

.status {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

@media screen and ( max-width: 1200px ){
  .resout {
  width: 900px;
  height: 409px;
  margin: 0 auto;
  margin-top: 63px;
  display: flex;
}
.notice-info-show2 {
  width: 57%;
}
.notice-title span.organize {
  margin-left: 120px;
}
.notice-title span.publish-time {
  margin-left: 100px;
}
.notice-list ul li .title-content {
  width: 150px;
  padding-right: 0px;
}
.notice-list ul li .organize-content {
  width: 140px;
  padding-right: 0px;
}
.notice-list ul li .time-content{
    margin-left: 24px;
}
}

</style>